import React, { Component } from 'react';
import './../css/master.css';
import './../css/wvrDispatch.css';
import WeaverHeader from './../js/weaverHeader.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';
import DatePicker from 'react-datepicker';
//import moment from 'moment';

var httpURL 	= '';
var queryString = require('querystring');
var lstDispatch	= [];

class WVRDispatch extends Component {
  constructor(props){
	super(props);
	this.state={
		designImagePath : require('./../images/blank.png'),
		loader:'none',
		opacity:1,
		flg: true,
		transporter:'',
		contactPerson:'',
		phone:'',
		dispatch:[],
		dispatchDate:null,
		totalQuantity:0,
		quantityColor:'',
	}
  }
  
  handleDispatch=(date)=>{
	this.setState({dispatchDate:date});
  }

  async componentDidMount(){
	var details = this.props.location.state.detail;
	$('#ipoId').val(details.ipoId);
	$('#ipoNo').val(details.ipoNo);
	$('#ipoDesignId').val(details.ipoDesignId);
	$('#designId').val(details.designId);
	$('#designNoColor').val(details.designNoColor);
	$('#quality').val(details.quality);
	$('#length').val(details.length);
	$('#width').val(details.width);
	$('#yarnCount').val(details.yarnCount);
	$('#construction').val(details.construction);
	  
	this.setState({loader:'block', opacity:0.5, designImagePath:details.imageUrl});
	axiosInstance.post(httpURL+'/w/po/disp/lsttrans',
	  queryString.stringify({'ipoId':$('#ipoId').val()}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			this.setState({
				transporter : response.data.lstTransporter.transporter,
				contactPerson : response.data.lstTransporter.contactPerson,
				phone : response.data.lstTransporter.phoneNo,
			});
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.WVRURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});

	this.dispatchFunction();
	this.handleResize();
	window.addEventListener("load", this.handleResize);
	window.addEventListener("resize", this.handleResize);
  }
  
  handleResize=()=>{
	var width1 = ($('.tableLayout1').parent().width())-17;
	this.setState({width1:width1})
  }
  
  dispatchFunction=()=>{
	axiosInstance.post(httpURL+'/w/po/disp/lstdispatch',
		queryString.stringify({'ipoDesignId':$('#ipoDesignId').val()}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			this.setState({
				dispatch : response.data.lstDispatch,
				totalQuantity:response.data.totalQuantity,
				quantityColor:$('#length').val() > response.data.totalQuantity ? 'red' : 'green',
			});
			lstDispatch = this.state.dispatch;
			$('#order_completed').prop('checked', response.data.orderCompleted);
			if(response.data.orderCompleted == true){
				$('#newDispatchForm input, button').attr('disabled', true);
			}
			this.setDispatchTable();
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'No Dispatch Data exist for this IPO Design'){
				lstDispatch = [];
				this.setDispatchTable();
			}

			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.WVRURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  setDispatchTable=()=>{
	$('#dispatchTbody tr').remove();  
	var table = document.getElementById('dispatchTable');
	var tbody = document.getElementById('dispatchTbody');

	for(var i=0; i<lstDispatch.length; i++){
		var dispatchId 	= lstDispatch[i].dispatchId;
		var dispatchDt 	= lstDispatch[i].dispatchDt;
		var invoiceNo	= lstDispatch[i].invoiceNo;
		var quantity	= lstDispatch[i].quantity;
		var statusId	= lstDispatch[i].statusId;
		var status		= lstDispatch[i].status;
		var wvrSubmitDt = lstDispatch[i].wvrSubmitDt;
		var actionDt 	= lstDispatch[i].csActionDt;
		
		var row = document.createElement('tr');
		this.addTD(row, dispatchId, 'text-right no-display');
		this.addTD(row, dispatchDt, 'text-center');
		this.addTD(row, invoiceNo, '');
		this.addTD(row, quantity, 'text-right');
		this.addTD(row, status, '')
		this.addTD(row, wvrSubmitDt, 'text-center');
		this.addTD(row, actionDt, 'text-center');
		this.addTDAction(row, statusId, 'glyphicon glyphicon-trash', 'text-center actions');

		tbody.append(row);
	}
	table.append(tbody);
  }

  addTD(row, val, classname){
	var cell = document.createElement('td');
	cell.className = classname;
	var text = document.createTextNode(val);
	cell.append(text);
	row.append(cell);
  }

  addTDAction(row, statusId, val, classname){
	var cell = document.createElement('td');
	cell.className = classname;
	var span = document.createElement('span');
	var span1 = document.createElement('span');
	span.className = val;
	span1.className='glyphicon glyphicon-edit'
	span1.style.cursor = 'pointer';
	span.style.cursor = 'pointer';
	if(statusId == 2){
		span.style.pointerEvents = 'none';
		span.style.color = 'gray';
	}else{
		span.style.pointerEvents = 'auto';
		span.style.color = '#111';
	}
	span.addEventListener('click', this.deleteDispatch);
	span1.onclick = () => {
		$('td').removeClass('selected');
		$(row).addClass('selected').siblings().removeClass('selected');
		var dispatchId = $('#dispatchTbody tr.selected').find('td:eq(0)').text();
		$('body').addClass('sliderOpen');
			this.setDispatchForm(dispatchId);
			this.setState({flg:false})
			$('.popupForm').show();	
	};
	cell.append(span);
	cell.append(span1);
	row.append(cell);
  }


	setDispatchForm =(id)=> {
		var dispatchData = this.getDispatchData(id);
		if(dispatchData !== -1){
			$('#inp_invoice1').val(dispatchData.invoiceNo);
			$('#inp_quantity1').val(dispatchData.quantity);

			var date = dispatchData.dispatchDt;
			date = date.split('-');
			var setDate = date.reverse().join();
			setDate = setDate.replace(/,/g, '-');
			var dispatchDt = new Date(setDate);
			this.setState({
				dispatchDate: dispatchDt,
			});
		}
	}

	getDispatchData(id){
		for(var i = 0; i < lstDispatch.length; i++){
			if(id == lstDispatch[i].dispatchId){
				return lstDispatch[i];
			}
		}
		return -1;
	}

  deleteDispatch=(e)=>{
	var ipoDesignId = $('#ipoDesignId').val();
	var dispatchId = $(e.target).closest('tr').find('td:eq(0)').text();
	var dispatch = {ipoDesignId, dispatchId}
	
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/w/po/disp/delete',
	  queryString.stringify({'dispatch':JSON.stringify(dispatch)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			toast.success(response.data.SvcMsg);
			$(e.target).closest('tr').remove();
			this.setState({
				totalQuantity:response.data.totalQuantity,
				quantityColor:$('#length').val() > response.data.totalQuantity ? 'red' : 'green',
			});
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.WVRURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  addDispatch=()=>{
	var dispatch = {};
	var dispatchId = 0;
	var ipoDesignId = $('#ipoDesignId').val();
	var invoiceNo = $('#inp_invoice').val();
	var dispatchDt = $('#dispatchDt').val();
	var quantity = $('#inp_quantity').val();
    var length = $('#length').val();
	
	if(invoiceNo == ''){
		toast.warning('Please fill invoice number');
		return false;
	}

	if(dispatchDt == ''){
		toast.warning('Please fill dispatch date');
		return false;
	}

	if(quantity == ''){
		toast.warning('Please fill quantity');
		return false;
	}

	dispatch = {dispatchId,ipoDesignId, invoiceNo, dispatchDt, quantity, length};
	
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/w/po/disp/save',
	  queryString.stringify({'dispatch':JSON.stringify(dispatch)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			toast.success(response.data.SvcMsg);
			dispatch.dispatchId = response.data.dispatchId;
			dispatch.status = response.data.status;
			dispatch.wvrSubmitDt = response.data.wvrSubmitDt;
			dispatch.csActionDt = '';
			lstDispatch.unshift(dispatch);
			this.setDispatchTable();
			$('#inp_invoice').val('');
			$('#dispatchDt').val('');
			$('#inp_quantity').val('');
			this.setState({
				dispatchDate:null,
				totalQuantity:response.data.totalQuantity,
				quantityColor:$('#length').val() > response.data.totalQuantity ? 'red' : 'green',
			});
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.WVRURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  editDispatch=()=>{

	var dispatch = {};
	var dispatchId = $('#dispatchTbody tr.selected').find('td:eq(0)').text();
	var ipoDesignId = $('#ipoDesignId').val();
	var invoiceNo = $('#inp_invoice1').val();
	var dispatchDt = $('#dispatchDt').val();
	var quantity = $('#inp_quantity1').val();
    var length = $('#length').val();
	
	if(invoiceNo == ''){
		toast.warning('Please fill invoice number');
		return false;
	}

	if(dispatchDt == ''){
		toast.warning('Please fill dispatch date');
		return false;
	}

	if(quantity == ''){
		toast.warning('Please fill quantity');
		return false;
	}

	dispatch = {dispatchId,ipoDesignId, invoiceNo, dispatchDt, quantity, length};
	
	this.setState({loader:'block', opacity:0.5});
	axiosInstance.post(httpURL+'/w/po/disp/save',
	  queryString.stringify({'dispatch':JSON.stringify(dispatch)}), {withCredentials: true}
	).then((response)=> {
		if(response.data.SvcStatus === 'Success'){
			toast.success(response.data.SvcMsg);
			$('.popupForm').hide();
			$('body').removeClass('sliderOpen');
			this.dispatchFunction();
			$('#inp_invoice').val('');
			$('#dispatchDt').val('');
			$('#inp_quantity').val('');
			this.setState({
				dispatchDate:null,
				totalQuantity:response.data.totalQuantity,
				quantityColor:$('#length').val() > response.data.totalQuantity ? 'red' : 'green',
			});
		}
		else{
			toast.error(response.data.SvcMsg);
			if(response.data.SvcMsg == 'You are not logged in'){
				window.location.href = window.WVRURL;
				return false;
			}
		}
		this.setState({loader:'none', opacity:1});
	}).catch((error)=> {
		toast.error("Service failed " + error);
	});
  }

  orderCompleted=(e)=>{
	console.log('Hello');
	var ipoDesignId = $('#ipoDesignId').val();
	if($(e.target).prop('checked')){
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.post(httpURL+'/w/po/disp/changeorder',
		queryString.stringify({'ipoDesignId':ipoDesignId}), {withCredentials: true}
		).then((response)=> {
			if(response.data.SvcStatus === 'Success'){
				toast.success(response.data.SvcMsg);
				$('#newDispatchForm input, button').attr('disabled', true);
			}
			else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.WVRURL;
					return false;
				}
				$('#order_completed').prop('checked', false);
			}
			this.setState({loader:'none', opacity:1});
		}).catch((error)=> {
			toast.error("Service failed " + error);
		});
	}	
  }

  maintainDispatch = () => {
	if (this.state.flg) {
		this.addDispatch();
	} else {
		this.editDispatch();
	}
}

hideSlider=()=>{
	$('.popupForm').hide();
	$('body').removeClass('sliderOpen');
	this.setState({
	  dispatchDate:null,
	});

}

  render() {
	httpURL = window.httpURL;  
	return (
		<div style={{height:'100%'}}>
			<WeaverHeader />
			<ToastContainer autoClose={2000} hideProgressBar />
			<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader, zIndex:9999}}>
				<img src={require("../images/loader.gif")} alt="Loader..."/>
			</div>
			<div className="main" style={{opacity:this.state.opacity}}>
				<div className="container-fluid">
					<div className="col-sm-12 col-centered">
						<div className="row">
							<div className="col-sm-10" style={{paddingLeft:0}}>
								<div className="styleBackground">
									<form className="form-inline">
										<div className="form-group">
											<label style={{width:60}} htmlFor="ipoNo">IPO NO:</label>
											<input style={{display:'none'}} placeholder="IPO Id" type="text" className="form-control" id="ipoId" />
											<input style={{display:'none'}} placeholder="IPO Design Id" type="text" className="form-control" id="ipoDesignId" />
											<input style={{marginLeft:5}} readOnly placeholder="IPO Number" type="text" className="form-control" id="ipoNo" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="designNoColor">Design Color:</label>
											<input style={{display:'none'}} placeholder="Design Id" type="text" className="form-control" id="designId" />
											<input style={{marginLeft:5}} readOnly placeholder="Design Color" type="text" className="form-control" id="designNoColor" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:60}} htmlFor="quality">Quality:</label>
											<input style={{marginLeft:5}} readOnly placeholder="Quality" type="text" className="form-control" id="quality" />
										</div>
									</form>
									<form className="form-inline" style={{marginTop:5}}>
										<div className="form-group">
											<label style={{marginLeft:0, width:60}} htmlFor="width">Width:</label>
											<input style={{marginLeft:5}} readOnly placeholder="Width" type="text" className="form-control" id="width" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:100}} htmlFor="yarnCount">Yarn Count:</label>
											<input style={{marginLeft:5}} readOnly placeholder="Yarn Count" type="text" className="form-control" id="yarnCount" />
										</div>
										<div className="form-group">
											<label style={{marginLeft:10, width:60}} htmlFor="length">Length:</label>
											<input style={{marginLeft:5, width:100}} readOnly placeholder="Length" type="text" className="form-control text-right" id="length" />
										</div>
										
										<div className="form-group">
											<label style={{marginLeft:10}} htmlFor="construction">Construction:</label>
											<input style={{marginLeft:5, width:100}} readOnly placeholder="Construction" type="text" className="form-control" id="construction" />
										</div>
									</form>
								</div>
								<div style={{marginTop:5, display:'flex', flexDirection:'row'}} className="styleBackground">
									<h4 style={{fontWeight:'bold', color:'#bb592b', width:200}}>Transporter Details</h4>
									<form className="form-inline">
										<div className="form-group">
											<label style={{width:100}} htmlFor="inp_transporter">Transporter:</label>
											<input readOnly type="text" value={this.state.transporter} id="inp_transporter" placeholder="Transporter" className='form-control' />
										</div>
										<div style={{marginLeft:20}} className="form-group">
											<label style={{width:120}} htmlFor="inp_contactPerson">Contact Person:</label>
											<input readOnly type="text" value={this.state.contactPerson} id="inp_contactPerson" className='form-control' placeholder="Contact Person" />
										</div>
										<div style={{marginLeft:20}} className="form-group">
											<label style={{width:60}} htmlFor="inp_phone">Phone:</label>
											<input readOnly style={{marginLeft:2, width:120}} value={this.state.phone} type="text" id="inp_phone" placeholder="Phone" className='form-control text-center' />
										</div>
									</form>
								</div>
							</div>
							<div className="col-sm-2 padding-remove" id="designColorImageDiv3">
								<ReactImageMagnify {...{
									smallImage: {
										alt: 'Design Image',
										src: this.state.designImagePath,
										isFluidWidth: true,
									},
									largeImage: {
										src: this.state.designImagePath,
										width: 600,
										height: 900
									},
									enlargedImageContainerDimensions:{
										width:300,
										height:300,
									},
									enlargedImageContainerStyle:{
										left:-170,
										top:140,
									},
								}} />
							</div>
						</div>
						<div className="row">
							<div style={{marginTop:5, display:'flex', flexDirection:'row', position:'relative'}} className="styleBackground">
								<h4 style={{fontWeight:'bold', color:'#bb592b', width:200}}>New Dispatch</h4>
								<form className="form-inline" id="newDispatchForm">
									<div className="form-group">
										<label style={{width:100}} htmlFor="inp_invoice">Invoice No.:<span style={{color:'red'}}>*</span></label>
										<input type="text" id="inp_invoice" placeholder="Invoice No." className='form-control' />
									</div>
									<div style={{marginLeft:20}} className="form-group">
										<label style={{width:120}} htmlFor="dispatchDt">Dispatch Date:<span style={{color:'red'}}>*</span></label>
										<div style={{display:'inline-block', width:120}}>
											<DatePicker id="dispatchDt"
												className='form-control inline-width text-center'
												placeholderText="Dispatch Date"
												selected={this.state.dispatchDate}
												onChange={this.handleDispatch}
												dateFormat="dd-MM-yyyy"
												autoComplete='off'
												//minDate= {new Date()}
											/>
										</div>
									</div>
									<div style={{marginLeft:20}} className="form-group">
										<label style={{width:80}} htmlFor="inp_quantity">Quantity:<span style={{color:'red'}}>*</span></label>
										<input style={{marginLeft:2, width:120}} type="text" id="inp_quantity" placeholder="Quantity" className='form-control text-right' />
									</div>
									<button style={{marginLeft:10}} onClick={this.maintainDispatch} type="button"className="btn btn-warning">Save</button>
									<div className="form-group" style={{position:'absolute', right:10, top:10}}>
										<label htmlFor="">Order Completed:</label>
										<div className="checkbox" style={{marginLeft:5}}>
											<input onChange={this.orderCompleted} type="checkbox" id="order_completed" />
										</div>
									</div> 
								</form>
							</div>
						</div>
						<div className="row" style={{marginTop:5, display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
							<div>
								<table className="tableLayout1" style={{width:this.state.width1}}>
									<thead>
										<tr>
											<th style={{width:50, display:'none'}}>Dispatch Id</th>
											<th style={{width:100}}>Dispatch Date</th>
											<th style={{width:100}}>Invoice No. </th>
											<th style={{width:100}}>Quantity</th>
											<th style={{width:100}}>Chandrasilk Status</th>
											<th style={{width:100}}>Submit Date</th>
											<th style={{width:100}}>Action Date</th>
											<th style={{width:50}}>Action</th>
										</tr>
									</thead>
								</table>
								<div style={{height:250, overflowY:'scroll'}}>
									<table className="tableLayout" id="dispatchTable">
										<colgroup>
											<col style={{width:100}} />
											<col style={{width:100}} />
											<col style={{width:100}} />
											<col style={{width:100}} />
											<col style={{width:100}} />
											<col style={{width:100}} />
											<col style={{width:50}} />
										</colgroup>
										<tbody id="dispatchTbody"></tbody>
									</table>
								</div>
							</div>
							<div>
								<span onClick={this.dispatchFunction} title="Refresh" style={{fontSize:20, paddingLeft:10, cursor:'pointer'}} className="glyphicon glyphicon-refresh"></span>
							</div>
						</div>	
						<div className="row text-right" style={{marginTop:20, marginRight:0}}>
							<span className="digitalFont" style={{fontSize:20, fontWeight:'bold', color:this.state.quantityColor}}>Total Quantity: {this.state.totalQuantity}</span>
						</div>

						<div className="row popupForm">
							<div className="styleBackground1">
								<h4 style={{fontWeight:'bold', color:'#bb592b'}}>Edit Dispatch</h4>
								<form className="form-horizontal" id="newDispatchForm1">
									<div className="form-group">
										<label className="col-sm-5" htmlFor="inp_invoice">Invoice No.:<span style={{color:'red'}}>*</span></label>
										<div className="col-sm-6">
										<input type="text" id="inp_invoice1" placeholder="Invoice No." className='form-control ' />
										</div>
									</div>
									<div className="form-group">
										<label className="col-sm-5" htmlFor="dispatchDt">Dispatch Date:<span style={{color:'red'}}>*</span></label>
										<div  style={{display:'inline-block'}} className="col-sm-6">
											<DatePicker id="dispatchDt"
												className='form-control inline-width text-center'
												placeholderText="Dispatch Date"
												selected={this.state.dispatchDate}
												onChange={this.handleDispatch}
												dateFormat="dd-MM-yyyy"
												autoComplete='off'
												minDate={this.state.minDate}
											/>
										</div>
									</div>
									<div className="form-group">
										<label className="col-sm-5" htmlFor="inp_quantity">Quantity:<span style={{color:'red'}}>*</span></label>
										<div className="col-sm-6">
											<input type="text" id="inp_quantity1" placeholder="Quantity" className='form-control text-right' />
										</div>
									</div>
									<div className="buttonWrap">
									<button style={{marginTop:20}} onClick={this.maintainDispatch} type="button"className="btn btn-warning">Save</button>
									</div>
									<span  className="cd-panel-close glyphicon glyphicon-remove" onClick={this.hideSlider}>Close</span>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    );
  }
}

export default WVRDispatch;
